import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';

import { IClientAdhesion } from '../model/client-adhesion';
import { IClientAdhesionList } from '../model/client-adhesion-list';
import { IClientAdhesionFilter } from '../model/client-adhesion-filter';
import { IPerson } from '../model/person';
import { SpinnerService } from './spinner.service';

@Injectable()
export class ClientAdhesionService {

  /**
   *
   * @type {string}
   */
  private privateClientAdhesionUrl = environment.apiUrl + '/v1/clients/';
  private privateInvoicingClientAdhesionUrl = environment.apiUrl + '/v1/invoicing-services/';

  /**
   *
   * @param {HttpClient} http
   * @param {SpinnerService} spinnerService
   */
  constructor(private http: HttpClient,
              private spinnerService: SpinnerService) { }

  /**
   * Save the client adhesion
   * @param clientAdhesion
   * @param person
   */
  saveClientAdhesion(clientAdhesion, person: IPerson): Observable<IClientAdhesion> {
    this.spinnerService.setSpinner(true);
    return this.http.post(this.privateClientAdhesionUrl + `${person.identifier}/adhesions`, clientAdhesion)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {IClientAdhesion} clientAdhesion
   * @param {string} url
   * @return {Observable<IClientAdhesion>}
   */
  updateClientAdhesion(clientAdhesion: IClientAdhesion, url: string): Observable<IClientAdhesion> {
    this.spinnerService.setSpinner(true);
    return this.http.patch(url, null)
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        if(error.status === 409){
          return Observable.throw('cli.clientAdhesion.errors.clientAdhesionStateConflict');
        }else {
          return Observable.throw(error);
        }
      });
  }


  /**
   *
   * @param {IClientAdhesion} clientAdhesion
   * @param {IPerson} person
   * @return {Observable<any | any>}
   */
  updateClientClientAdhesion(clientAdhesion: IClientAdhesion, person: IPerson): Observable<IClientAdhesion> {
    let url = this.privateClientAdhesionUrl + `${person.identifier}/adhesions/${clientAdhesion.id}`;
    return this.updateClientAdhesion(clientAdhesion, url);
  }

  /**
   *
   * @param {IClientAdhesion} clientAdhesion
   * @param {string} identifier
   * @return {Observable<IClientAdhesion>}
   */
  updateInvoicingClientAdhesion(clientAdhesion: IClientAdhesion, identifier: string): Observable<IClientAdhesion> {
    let url = this.privateInvoicingClientAdhesionUrl + `${identifier}/adhesions/${clientAdhesion.id}`;
    return this.updateClientAdhesion(clientAdhesion, url);
  }

  /**
   *
   * @param {string} identifier
   * @param {IClientAdhesionFilter} filter
   * @return {Observable<IClientAdhesionList>}
   */
  getClientAdhesions(identifier: string, filter: IClientAdhesionFilter): Observable<IClientAdhesionList> {
    this.spinnerService.setSpinner(true);
    filter.invoicingService = filter.invoicingService.trim();
    filter.dire = filter.dire.trim();
    filter.status = filter.status.trim();
    const url = this.privateClientAdhesionUrl + `${identifier}/adhesions`;
    return this.http.get<IClientAdhesionList>(url, { params: filter as any })
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }

  /**
   *
   * @param {string} identifier
   * @param {IClientAdhesionFilter} filter
   * @return {Observable<IClientAdhesionList>}
   */
  getInvoicingClientAdhesions(identifier: string, filter: IClientAdhesionFilter): Observable<IClientAdhesionList> {
    this.spinnerService.setSpinner(true);
    filter.invoicingService = filter.invoicingService.trim();
    filter.dire = filter.dire.trim();
    filter.status = filter.status.trim();
    const url = this.privateInvoicingClientAdhesionUrl + `${identifier}/adhesions`;

    return this.http.get<IClientAdhesionList>(url, { params: filter as any })
      .map(res => {
        this.spinnerService.setSpinner(false);
        return res;
      })
      .catch(error => {
        this.spinnerService.setSpinner(false);
        return Observable.throw(error);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/client-adhesion.service.ts